<ng-progress [spinner]="false" class="progress-bar" [color]="'#ff4081'"></ng-progress>
<router-outlet></router-outlet>
